export interface ApiErrorShape { errorType: string; status: number; userMessage?: string | null; info?: unknown; }
export class ApiError extends Error {
  readonly errorType: string; readonly status: number; readonly userMessage?: string | null; readonly info?: unknown;
  constructor(shape: ApiErrorShape) {
    super(`${shape.errorType} (${shape.status})${shape.userMessage ? `: ${shape.userMessage}` : ""}`);
    this.name = "ApiError"; this.errorType = shape.errorType; this.status = shape.status;
    this.userMessage = shape.userMessage; this.info = shape.info;
  }
}
